import React from 'react';
import landingBg from 'assets/images/home/home-landing-bg.jpg';
import TitleArea from 'components/common/content/title';
import RoutesRegistry from 'services/router/registry';
import { Breadcrumb } from 'components/common/breadcrumb/types';
import { CourseAPI } from 'api';
import { useParams } from 'react-router';
import Container from 'components/common/section-container';
import translate from 'i18n/translate';
import AdmissionForm from './admission-form';
import { AdmissionFormData } from './types';
import { set } from 'lodash';

const NewAdmissionInformation = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { id } = useParams();
  const urlParams = new URLSearchParams(window.location.search);
  const courseId = urlParams.get('courseId');
  const returnUrl = urlParams.get('returnUrl');

  const crumbs: Breadcrumb[] = [
    RoutesRegistry.Courses,
    {
      title: RoutesRegistry.Courses.Course.title,
      path: `${RoutesRegistry.Courses.path}/${courseId}`,
    },
    {
      title: RoutesRegistry.AdmissionInfoForm.title,
    },
  ];

  const handleSubmit = async (data: AdmissionFormData) => {
    const formData = {
      full_name: data.fullName,
      index_number: data.indexNumber,
      id_number: data.nicNumber,
      district: data.district,
      contact_number: data.contactNumber,
      course_restriction_id: Number(id),
    };

    setIsLoading(true);

    const res: any = await CourseAPI.createAdmissionInfo(Number(id), formData);

    if (res?.status) {
      setIsLoading(false);
      window.location.href = returnUrl || RoutesRegistry.Dashboard.path;
    }
  };

  return (
    <>
      <TitleArea
        backgroundImg={landingBg}
        icon="charted-acc"
        breadcrumbs={crumbs}
        title={translate('admissionInformation.title', true)}
      />

      <Container className="intro-container">
        <div className="content">
          {translate('admissionInformation.description', true)}
        </div>

        <AdmissionForm onSubmit={handleSubmit} isLoading={isLoading} />
      </Container>
    </>
  );
};

export default NewAdmissionInformation;
